import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlockNavigationService {

  private processingSubject = new BehaviorSubject<boolean>(false);
  private _title: string = 'Calculation in Progress';
  private _message: string = `Leaving this page now may interrupt the process and lead to an incomplete or incorrect result.<br/><br/>Please wait until the calculation completes, or choose to leave if you're sure.`;

  processing$: Observable<boolean> = this.processingSubject.asObservable();

  blockNavigation(status: boolean, title?: string, message?: string): void {
    console.log(`blockNavigation: ${status}`);
    if (status) {
      this._title = title || 'Calculation in Progress';
      this._message = message || `Leaving this page now may interrupt the process and lead to an incomplete or incorrect result.<br/><br/>Please wait until the calculation completes, or choose to leave if you're sure.`;
    }
    this.processingSubject.next(status);
  }

  isBlocked(): boolean {
    return this.processingSubject.value;
  }

  getTitle(): string {
    return this._title;
  }

  getMessage(): string {
    return this._message;
  }
}
